import { render, staticRenderFns } from "./todo.vue?vue&type=template&id=bd1d50c8&scoped=true"
import script from "./todo.vue?vue&type=script&lang=js"
export * from "./todo.vue?vue&type=script&lang=js"
import style0 from "./todo.vue?vue&type=style&index=0&id=bd1d50c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1d50c8",
  null
  
)

export default component.exports